export var CALCULATOR_DECISIONS;
(function (CALCULATOR_DECISIONS) {
    CALCULATOR_DECISIONS[CALCULATOR_DECISIONS["ADD_UNDERFUNDING_TO_LOAN_AMOUNT"] = 0] = "ADD_UNDERFUNDING_TO_LOAN_AMOUNT";
    CALCULATOR_DECISIONS[CALCULATOR_DECISIONS["ADD_UNDERFUNDING_TO_AVAILABLE_EQUITY"] = 1] = "ADD_UNDERFUNDING_TO_AVAILABLE_EQUITY";
    CALCULATOR_DECISIONS[CALCULATOR_DECISIONS["NEED_ADVICE"] = 2] = "NEED_ADVICE";
})(CALCULATOR_DECISIONS || (CALCULATOR_DECISIONS = {}));
